import { Container } from '@mui/material';
import React, {FC, useCallback, useEffect, useRef, useState} from 'react';
import {theme} from 'thermia-react-container';
import useIsMounted from '../../../hooks/useIsMounted';
import { useRegistrationService } from '../../../service/registrationService';
import {Registration} from '../../../types/registrationTypes';
import AdminTabs from "../components/adminTabs";
import {useNavigate, useParams} from "react-router-dom";
import AdminRegistrationsTable from "./components/adminRegistrationsTable";
import AdminRegistrationsSearch from "./components/adminRegistrationsSearch";

const AdminRegistrations: FC = () => {
  const [loading, setLoading] = useState(false);
  const isMounted = useIsMounted();
  const { fetchAdminRegistrations } = useRegistrationService(true);
  const [searchResults, setSearchResults] = useState<Registration[]>([]);
  let { search } = useParams<{ search: string }>();
  const [textInput, setTextInput] = useState<string>(search ?? '');
  const navigate = useNavigate();
  const handleFetchAdminRegistrations = useCallback(async () => {
    try {
      const searchTerm = textInput.trim();
      if(searchTerm === '') {
        return;
      }
      setLoading(true);
      const response: any = await fetchAdminRegistrations(searchTerm);
      setSearchResults([response]);
    } catch (e) {
      setSearchResults([]);
    }
    if (isMounted) {
      setLoading(false);
    }
  }, [fetchAdminRegistrations, isMounted, textInput]);
  
  const setSearch = () => {
    navigate('/admin/registrations/' + textInput.trim());
  }
  
  const lastSearchRef = useRef<string>('');
  const doSearch = useCallback(() => {
    if(search && search !== lastSearchRef.current) {
      lastSearchRef.current = search;
      setTextInput(search);
      handleFetchAdminRegistrations();
    }
  }, [search, handleFetchAdminRegistrations]);
  
  useEffect(() => doSearch(), [doSearch]);

  return (
    <Container maxWidth="xl" sx={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(50) }}>
      <AdminTabs tab={'registrations'} />
      <AdminRegistrationsSearch 
        isLoadingResults={loading} 
        searchAction={setSearch} 
        setTextInput={setTextInput} 
        textInput={textInput} 
      />
      <AdminRegistrationsTable
        adminRegistrations={searchResults}
        updateList={handleFetchAdminRegistrations}
      />
    </Container>
  );
};

export default AdminRegistrations;
